export default __webpack_public_path__ + "static/media/Icon_Shopify.238c498b.svg";